import { createSlice } from '@reduxjs/toolkit';
import initialState from './initialState';
import { saveSheetReducer } from './spreadsheetReducer';

export const spreadsheetSlice = createSlice({
  name: 'spreadsheet',
  initialState,
  reducers: {
    saveSheet: saveSheetReducer
  }
});

export const { saveSheet } = spreadsheetSlice.actions;

export default spreadsheetSlice.reducer;
